export { default } from './PageHeader'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Page/PageHeader/index.js